import React, { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import SEO from '../SEO';
import { portalApi } from '../../lib/portalApi';
import { ArrowRight } from 'lucide-react';

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters');
      return;
    }
    setLoading(true);
    try {
      await portalApi.resetPassword(token, password);
      navigate('/login');
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <section className="min-h-screen bg-[#08080a] flex items-center justify-center p-6">
        <div className="text-center text-white/60">
          <p>Invalid reset link.</p>
          <Link to="/forgot-password" className="text-[#ff8ec5] hover:underline mt-4 inline-block">Request a new link</Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <SEO title="Reset Password" description="Choose a new password for your InnovHer portal account." />
      <section className="min-h-screen bg-[#08080a] flex items-center justify-center p-6 pt-24">
        <div className="w-full max-w-md bg-white/[0.02] border border-white/10 p-8 rounded-3xl">
          <h1 className="text-2xl font-semibold text-white mb-6">Set new password</h1>
          <form onSubmit={submit} className="space-y-4">
            {error && <div className="p-3 rounded-lg bg-red-500/10 text-red-400 text-sm">{error}</div>}
            <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white" placeholder="New password" />
            <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} className="w-full bg-black/40 border border-white/10 rounded-xl px-4 py-3 text-white" placeholder="Confirm password" />
            <button type="submit" disabled={loading} className="w-full bg-[#d42b92] hover:bg-[#ff8ec5] text-white py-3 rounded-xl font-medium disabled:opacity-50">
              {loading ? 'Saving...' : 'Reset password'} <ArrowRight className="w-4 h-4 inline" />
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
